import { createDetailedValidator, registerType } from 'typecheck.macro';

export const SearchPromotionResponseValidator = createDetailedValidator<SearchPromotionResponse>();

registerType('SearchPromotionResponse');

export interface SearchPromotionResponse {
  data: SearchPromotionItem[];
}

export interface SearchPromotionItem {
  type: 'specialty' | 'telehealth';
  title: string;
  altTitle: string | null;
  subtitle: string | null;
  icon: string;
  badge: null | 'NEW';

  topNavTitle?: string; //optional top-nav only name that 'replaces' the 'name' string for DISPLAY ONLY. not for search bar input.
}
